import { AuthenticationMethod } from "../commons/authenticationMethods";
import { SimpleHttpAdapterImpl } from "../SimpleHttpAdapter/SimpleHttpAdapterImpl";
import { HttpAdapter } from "./HttpAdapter";
import { mapRootKeysToCamelCase, mapRootKeysToSnakeCase } from "~/utils/mapKeys";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export class HttpAdapterImpl implements HttpAdapter {
    readonly #simpleHttpAdapter: HttpAdapter;

    constructor(ctx: ContextManager) {
        this.#simpleHttpAdapter = new SimpleHttpAdapterImpl(ctx);
    }

    public async get<T>(
        url: string,
        authMethod?: AuthenticationMethod,
        options?: { [key: string]: unknown; headers?: object }
    ): Promise<T> {
        let response: Response;
        try {
            response = await this.#simpleHttpAdapter.get(url, authMethod, options);
        } catch (error) {
            return Promise.reject(error instanceof Error ? error : new Error(String(error)));
        }
        return mapRootKeysToCamelCase(response) as Promise<T>;
    }

    public async post<T>(
        url: string,
        authMethod?: AuthenticationMethod,
        body?: {},
        options?: { [key: string]: unknown; headers?: object },
        requestContentType?: string
    ): Promise<T> {
        let response: Response;
        try {
            response = await this.#simpleHttpAdapter.post(
                url,
                authMethod,
                this.mapBody(body),
                options,
                requestContentType
            );
        } catch (error) {
            return Promise.reject(error instanceof Error ? error : new Error(String(error)));
        }
        return mapRootKeysToCamelCase(response) as Promise<T>;
    }

    public async put<T>(
        url: string,
        authMethod?: AuthenticationMethod,
        body?: {},
        requestContentType?: string
    ): Promise<T> {
        let response: Response;
        try {
            response = await this.#simpleHttpAdapter.put(url, authMethod, this.mapBody(body), requestContentType);
        } catch (error) {
            return Promise.reject(error instanceof Error ? error : new Error(String(error)));
        }
        return mapRootKeysToCamelCase(response) as Promise<T>;
    }

    public async delete<T>(url: string, authMethod?: AuthenticationMethod): Promise<T> {
        let response: Response;
        try {
            response = await this.#simpleHttpAdapter.delete(url, authMethod);
        } catch (error) {
            return Promise.reject(error instanceof Error ? error : new Error(String(error)));
        }
        return mapRootKeysToCamelCase(response) as Promise<T>;
    }

    public setIsEdgeSupported(isEdgeSupported: boolean = false): void {
        this.#simpleHttpAdapter.setIsEdgeSupported(isEdgeSupported);
    }

    private mapBody(body: object | undefined): string | undefined {
        if (body) {
            return JSON.stringify(mapRootKeysToSnakeCase(body));
        }
        return body;
    }
}
